function matchRuleShort(str, rule){
    let escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(str);
  }
  
  function getProductDetails(email, bc_customer_no, sku, sp_product_id, sp_variant_id, retail_price, title){
    retail_price = retail_price / 100;
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
    });
    let data = {
        "email": email,
        "bc_customer_no": bc_customer_no,
        "sku": sku,
        "title": title,
        "sp_product_id": sp_product_id,
        "sp_variant_id": sp_variant_id,
        "retail_price": retail_price
    };

    $.ajax({
        url: "https://ama.thecut.net.au/ama20/api/product",
        method: "POST",
        dataType: "json",
        data: JSON.stringify(data),
        success: function(data){

          if(data.message){
            $("#wholesalePriceIncGst").text("");
            $("#wholesalePriceIncGst").addClass('remove-after');

            $("#wholesalePriceExcGst").text("");
            $("#wholesalePriceExcGst").addClass('remove-after');

            $(".original").css("display", "flex");
          }
          else{
            let price_to_compare = 0;
            if(matchRuleShort(data.vat_prod_posting_group, "*FREE") || data.vat_prod_posting_group == "*NOGST"){
                price_to_compare = data.unit_price;
            }
            else{
                price_to_compare = data.unit_price_with_gst;
            }
              
            if(data.retail_price < price_to_compare){
              console.log("mas mababa retail price" + data.retail_price + " " + data.unit_price_with_gst);
              $("#wholesalePriceIncGst").text("");
              $("#wholesalePriceIncGst").addClass('remove-after');

              $("#wholesalePriceExcGst").text("");
              $("#wholesalePriceExcGst").addClass('remove-after');

              $("#wholesalePriceExmGst").text("");
              $("#wholesalePriceExmGst").addClass('remove-after');

              $(".original").css("display", "flex");
            }
            else{
              $("#wholesalePriceIncGst").removeClass('remove-after');
              $("#wholesalePriceExcGst").removeClass('remove-after');
              $("#wholesalePriceExmGst").removeClass('remove-after');
                if(matchRuleShort(data.vat_prod_posting_group, "*FREE") || data.vat_prod_posting_group == "*NOGST"){
                  //wholesale
                  if(wholesale_price_identify){
                    $("#wholesalePriceIncGst").text("Wholesale Price: $" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExcGst").text("Wholesale Price: $" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExmGst").text("Wholesale Price: $" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                  }
                  else{
                    $("#wholesalePriceIncGst").text("$" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExcGst").text("$" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExmGst").text("$" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                  }
                  $(".productId" + data.product_id).text("");
                  $(".badge").text("");
                }
                else{
                  //wholesale
                  if(wholesale_price_identify){
                    $("#wholesalePriceIncGst").text("Wholesale Price: $" + formatter.format(data.unit_price_with_gst).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExcGst").text("Wholesale Price: $" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExmGst").text("Wholesale Price: $" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                  }
                  else{
                    $("#wholesalePriceIncGst").text("$" + formatter.format(data.unit_price_with_gst).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExcGst").text("$" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                    $("#wholesalePriceExmGst").text("$" + formatter.format(data.unit_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                  }
                  
                  $(".productId" + data.product_id).text("");
                  $(".badge").text("");
                }
            }
          }
        }
    });
  }
  
  function cartPage(details){
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
    });
    Number.prototype.toFixedDown = function(digits) {
        var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
            m = this.toString().match(re);
        return m ? parseFloat(m[1]) : this.valueOf();
    };
    $.ajax({
        url: "https://ama.thecut.net.au/ama20/api/cart",
        method: "POST",
        dataType: "json",
        data: JSON.stringify(details),
        success: function(data){
          if(data.items === null) return;
            let subtotal = 0;
            let subtotal_no_gst = 0;
            let minus = 0;
            let price_to_compare = 0;
              for (let i = 0; i < data.items.length; i++) {
                let line_item_id = data.items[i].line_item_id;
                line_item_id = line_item_id.replace(":", "\\:");
                if(data.items[i].message == "Not found."){
                    $(".original" + line_item_id).css("display", "flex");
                    if(details.items[i].tag == "true"){
                      subtotal_no_gst += Number(((Number(data.items[i].retail_price.replace(",", ""))) * data.items[i].quantity));
                    }
                    else{
                      subtotal_no_gst += Number(((Number(data.items[i].retail_price.replace(",", "")) * 100 * data.items[i].quantity) / 110));
                    }                    
                }
                else{
                  if(matchRuleShort(data.items[i].vat_prod_posting_group, "*FREE") || data.items[i].vat_prod_posting_group == "*NOGST"){
                      price_to_compare = data.items[i].unit_price;
                  }
                  else{
                      price_to_compare = data.items[i].unit_price_with_gst;
                  }
                  if(Number(data.items[i].retail_price.replace(",", "")) < price_to_compare){
                      $(".original" + line_item_id).css("display", "flex");
                      subtotal_no_gst += Number(((Number(data.items[i].retail_price.replace(",", "")) * 100 * data.items[i].quantity) / 110));
                  }
                  else{
                      if(wholesale_price_identify){
                        $(".original" + line_item_id).css("display", "flex");
                      }
                      else{
                        $(".original" + line_item_id).css("display", "none");
                      }
                      $(".original" + line_item_id).css("text-decoration", "line-through");
                      if(matchRuleShort(data.items[i].vat_prod_posting_group, "*FREE") || data.items[i].vat_prod_posting_group == "*NOGST"){
                          $('#itemIncGst' + line_item_id).text("$" + (data.items[i].unit_price * data.items[i].quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          $('#itemExcGst' + line_item_id).text("$" + (data.items[i].unit_price * data.items[i].quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          minus += Number((data.items[i].retail_price.replace(",", "") * data.items[i].quantity).toFixed(2) - (data.items[i].unit_price * data.items[i].quantity).toFixed(2));
                        }
                      else{
                          $('#itemIncGst' + line_item_id).text("$" + (data.items[i].unit_price_with_gst * data.items[i].quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          $('#itemExcGst' + line_item_id).text("$" + (data.items[i].unit_price * data.items[i].quantity).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          minus += Number((data.items[i].retail_price.replace(",", "") * data.items[i].quantity).toFixed(2) - (data.items[i].unit_price_with_gst * data.items[i].quantity).toFixed(2));
                      }
                      subtotal_no_gst += Number((Number(data.items[i].unit_price) * data.items[i].quantity));                      
                  }
                }
              }
              
              subtotal = Number($(".totals__subtotal-value.IncGst").text().slice(0, -3).substring(1).replace(",", "")) - Number(minus.toFixed(2));
              $(".totals__subtotal-value.IncGst").html("$" + formatter.format(subtotal) + " AUD");

              $(".totals__subtotal-value.ExcGst").html("$" + formatter.format(subtotal_no_gst.toFixedDown(2)) + " AUD");
        }
    });
  }

  function getCartTotal(original_price, shipping_threshold, details, page){
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,      
      maximumFractionDigits: 2,
    });
    Number.prototype.toFixedDown = function(digits) {
        var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
            m = this.toString().match(re);
        return m ? parseFloat(m[1]) : this.valueOf();
    };

    $(".cart__total.small-hide.IncGst").addClass('remove-after');
    $(".cart__total.small-hide.ExcGst").addClass('remove-after');

    $.ajax({
        url: "https://ama.thecut.net.au/ama20/api/cart",
        method: "POST",
        dataType: "json",
        data: JSON.stringify(details),
        success: function(data){
          if(data.items === null) return;
            let subtotal = 0;
            let subtotal_no_gst = 0;
            let minus = 0;
            
              for (let i = 0; i < data.items.length; i++) {
                let line_item_id = data.items[i].line_item_id;
                line_item_id = line_item_id.replace(":", "\\:");
                if(data.items[i].message == "Not found."){
                    if(data.items[i].tags.includes("GSTExempt") || details.items[i].gst_exempt == true || details.items[i].tag == "true" ){
                      subtotal_no_gst += Number(((Number(data.items[i].retail_price.replace(",", ""))) * data.items[i].quantity));
                    }
                    else{
                      subtotal_no_gst += Number((Number(data.items[i].retail_price.replace(",", "")) * 100 * data.items[i].quantity) / 110);
                    }
                }
                else{
                  if(matchRuleShort(data.items[i].vat_prod_posting_group, "*FREE") || data.items[i].vat_prod_posting_group == "*NOGST"){
                      price_to_compare = data.items[i].unit_price;
                  }
                  else{
                      price_to_compare = data.items[i].unit_price_with_gst;
                  }
                  if(Number(data.items[i].retail_price.replace(",", "")) < price_to_compare){
                      subtotal_no_gst += Number(((Number(data.items[i].retail_price.replace(",", "")) * 100 * data.items[i].quantity) / 110));
                  }
                  else{
                      if(matchRuleShort(data.items[i].vat_prod_posting_group, "*FREE") || data.items[i].vat_prod_posting_group == "*NOGST" ){
                          minus += Number((data.items[i].retail_price.replace(",", "") * data.items[i].quantity).toFixed(2) - (data.items[i].unit_price * data.items[i].quantity).toFixed(2));
                      }
                      else{
                          minus += Number((data.items[i].retail_price.replace(",", "") * data.items[i].quantity).toFixed(2) - (data.items[i].unit_price_with_gst * data.items[i].quantity).toFixed(2));
                      }
                      subtotal_no_gst += Number((Number(data.items[i].unit_price) * data.items[i].quantity)); 
                  }
                }
                  
              }
              subtotal = (Number(original_price) / 100) - Number(minus.toFixed(2));
              
              if(page == "cart"){
                if(subtotal < shipping_threshold){
                  $(".messages__free-shipping").text("You are $" + (Number(shipping_threshold) - Number(subtotal)).toFixed(2) + " away from Free Shipping");
                }
                else{
                  $(".messages__free-shipping").text("You are eligible for free shipping");
                }
                $(".title-messages").css("display", "block");
              }
              else if(page == "add to cart"){
                
                if($(".gst-enabler").is(":checked")){
                    $("#cart-notification-total.ExcGst").css('display', 'none');
                    $("#cart-notification-total.IncGst").text("$" + formatter.format(subtotal));
                    $("#cart-notification-total.IncGst").addClass('remove-after');
                    $("#cart-notification-total.IncGst").css('display', 'block');
                }
                else{
                    $("#cart-notification-total.IncGst").css('display', 'none');
                    $("#cart-notification-total.ExcGst").text("$" + formatter.format(subtotal_no_gst.toFixedDown(2)));
                    //$("#cart-notification-total.ExcGst").text("$" + formatter.format(subtotal_no_gst));
                    $("#cart-notification-total.ExcGst").addClass('remove-after');
                    $("#cart-notification-total.ExcGst").css('display', 'block');
                }
                
                if(subtotal < shipping_threshold){
                  $(".shipping__message").text("You are $" + (Number(shipping_threshold) - Number(subtotal)).toFixed(2) + " away from Free Shipping");
                }
                else if(shipping_threshold == 0) {
                  $('.cart-notification__shipping').hide();
                  $('#cart-notification').css('padding-bottom', '25px');
                }
                else{
                  $(".shipping__message").text("You are eligible for free shipping");
                }

                
              }
              
              $(".cart__total.small-hide.IncGst").text("$" + formatter.format(subtotal));
              $(".cart__total.small-hide.IncGst").addClass('remove-after');
              $(".cart__total.small-hide.ExcGst").text("$" + formatter.format(subtotal_no_gst.toFixedDown(2)));
              $(".cart__total.small-hide.ExcGst").addClass('remove-after');
              
        },
        error: function (data, errorThrown) {
          console.log(data + "cart2 " + errorThrown);
        }
    });
  }

  function getCartContent(product_id, gst_exempt){
    $.ajax({
      url: "/cart.json",
      method: "get",
      success: function(data){
        if(data.items === null) return;
        let build_items = [];
        for(let i = 0; i < data.items.length; i++){
            if(product_id == data.items[i].product_id){
                build_items[i] = {
                    "line_item_id": data.items[i].key,
                    "product_id": data.items[i].product_id,
                    "sku": data.items[i].sku,
                    "variant_id": data.items[i].variant_id,
                    "retail_price": (Number(data.items[i].price) / 100).toString(),
                    "quantity": data.items[i].quantity,
                    "gst_exempt": gst_exempt
                } 
            }
            else{
                build_items[i] = {
                  "line_item_id": data.items[i].key,
                  "product_id": data.items[i].product_id,
                  "sku": data.items[i].sku,
                  "variant_id": data.items[i].variant_id,
                  "retail_price": (Number(data.items[i].price) / 100).toString(),
                  "quantity": data.items[i].quantity
                }
            }
        }
        let build_data = {
            "customer_email": customerEmail,
            "customer_no": customerNo,
            "note": data.note,
            "items": build_items
        }
        getCartTotal(data.items_subtotal_price, free_shipping_threshold, build_data, "add to cart");
      }
    });
  }
  
  function quote(details, PO, note, bc_customer_no){
      details.purchase_order = PO;
      details.note = note;
      details.bc_customer_no = bc_customer_no;
      $.ajax({
        url: "https://ama.thecut.net.au/ama20/api/quote",
        method: "POST",
        data: JSON.stringify(details),
        success: function(data){
            location.href = data;
        },
        error: function (data, errorThrown) {
          console.log(data + "ASD" + errorThrown);
        }
      });
  }

  function collection(details){
      $.ajax({
          url: "https://ama.thecut.net.au/ama20/api/collection-grid",
          method: "POST",
          dataType: "json",
          data: JSON.stringify(details),
          success: function(data){
              $(".original").css("display", "flex");
              for(let i = 0; i < data.length; i++){
                  if(!data[i].message){
                    if(matchRuleShort(data[i].vat_prod_posting_group, "*FREE") || data[i].vat_prod_posting_group == "*NOGST"){
                        price_to_compare = data[i].unit_price;
                    }
                    else{
                        price_to_compare = data[i].unit_price_with_gst;
                    }
                    // console.log(data[i].product_id + " retail:" + data[i].retail_price + " price2compare:" + price_to_compare);
                    // if(data[i].retail_price < price_to_compare){
                    if(data[i].retail_price < price_to_compare || price_to_compare == 0){
                        $(".wholesale.productId" + data[i].product_id).remove();
                    }
                    else{
                        if(data[i].is_many == "yes"){
                            if(matchRuleShort(data[i].vat_prod_posting_group, "*FREE") || data[i].vat_prod_posting_group == "*NOGST"){
                                //wholesale
                                if(wholesale_price_identify){
                                  $(".wholesale.productId" + data[i].product_id).text("Wholesale Price: From $" + (data[i].unit_price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                                else{
                                  $(".wholesale.productId" + data[i].product_id).text("From $" + (data[i].unit_price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                                $('.productId' + data[i].product_id).not('.wholesale').remove();
                            }
                            else{
                                //wholesale
                                if(wholesale_price_identify){
                                  $(".IncGst.wholesale.productId" + data[i].product_id).text("Wholesale Price: From $" + data[i].unit_price_with_gst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExcGst.wholesale.productId" + data[i].product_id).text("Wholesale Price: From $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExmGst.wholesale.productId" + data[i].product_id).text("Wholesale Price: From $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                                else{
                                  $(".IncGst.wholesale.productId" + data[i].product_id).text("From $" + data[i].unit_price_with_gst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExcGst.wholesale.productId" + data[i].product_id).text("From $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExmGst.wholesale.productId" + data[i].product_id).text("From $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                               $('.productId' + data[i].product_id).not('.wholesale').remove();
                            }
                        }
                        else{
                            if(matchRuleShort(data[i].vat_prod_posting_group, "*FREE") || data[i].vat_prod_posting_group == "*NOGST"){
                                //wholesale
                                if(wholesale_price_identify){
                                  $(".wholesale.productId" + data[i].product_id).text("Wholesale Price: $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                                else{
                                  $(".wholesale.productId" + data[i].product_id).text("$" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                
                                }
                                $('.productId' + data[i].product_id).not('.wholesale').remove();
                            }
                            else{
                                //wholesale
                                if(wholesale_price_identify){
                                  $(".IncGst.wholesale.productId" + data[i].product_id).text("Wholesale Price: $" + data[i].unit_price_with_gst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExcGst.wholesale.productId" + data[i].product_id).text("Wholesale Price: $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExmGst.wholesale.productId" + data[i].product_id).text("Wholesale Price: $" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                                else{
                                  $(".IncGst.wholesale.productId" + data[i].product_id).text("$" + data[i].unit_price_with_gst.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExcGst.wholesale.productId" + data[i].product_id).text("$" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                  $(".ExmGst.wholesale.productId" + data[i].product_id).text("$" + data[i].unit_price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                                }
                                $('.productId' + data[i].product_id).not('.wholesale').remove();
                            }
                        }
                    }
                  }
                  else{
                      $(".wholesale.productId" + data[i].product_id).remove();
                  }
              }
          }
      });
  }

  function collection2(details){
    Number.prototype.toFixedDown = function(digits) {
        var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
            m = this.toString().match(re);
        return m ? parseFloat(m[1]) : this.valueOf();
    };

    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,      
        maximumFractionDigits: 2,
    });
    
    $.ajax({
        url: "https://ama.thecut.net.au/ama20/api/collection-list",
        method: "POST",
        dataType: "json",
        data: JSON.stringify(details),
        success: function(data){
            for(let i = 0; i < data.length; i++){
                if(!data[i].message){
                  if(matchRuleShort(data[i].vat_prod_posting_group, "*FREE") || data[i].vat_prod_posting_group == "*NOGST"){
                      price_to_compare = data[i].unit_price;
                  }
                  else{
                      price_to_compare = data[i].unit_price_with_gst;
                  }
                  if(data[i].retail_price < price_to_compare){
                      $(".mainOriginal").css("display", "flex");
                      $(".wholesale.variantId" + data[i].variant_id).remove();
                  }
                  else{
                    $(".orig.variantId" + data[i].variant_id).parent().remove();
                      if(matchRuleShort(data[i].vat_prod_posting_group, "*FREE") || data[i].vat_prod_posting_group == "*NOGST"){
                          //wholesale
                          if(wholesale_price_identify){
                            $(".wholesale.variantId" + data[i].variant_id + ".IncGst").text("Wholesale Price: $" + formatter.format((data[i].unit_price).toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                            $(".wholesale.variantId" + data[i].variant_id + ".ExcGst").text("Wholesale Price: $" + formatter.format((data[i].unit_price).toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          }
                          else{
                            $(".wholesale.variantId" + data[i].variant_id + ".IncGst").text("$" + formatter.format((data[i].unit_price).toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                            $(".wholesale.variantId" + data[i].variant_id + ".ExcGst").text("$" + formatter.format((data[i].unit_price).toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          }
                          $('.variantId' + data[i].variant_id).not('.wholesale').remove();
                      }
                      else{
                          //wholesale
                          if(wholesale_price_identify){
                            $(".wholesale.variantId" + data[i].variant_id + ".IncGst").text("Wholesale Price: $" + formatter.format(data[i].unit_price_with_gst.toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                            $(".wholesale.variantId" + data[i].variant_id + ".ExcGst").text("Wholesale Price: $" + formatter.format((data[i].unit_price).toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          }
                          else{
                            $(".wholesale.variantId" + data[i].variant_id + ".IncGst").text("$" + formatter.format(data[i].unit_price_with_gst.toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                            $(".wholesale.variantId" + data[i].variant_id + ".ExcGst").text("$" + formatter.format((data[i].unit_price).toFixedDown(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                          
                          }
                          $('.variantId' + data[i].variant_id).not('.wholesale').remove();
                      }
                  }
                }
                else{
                    $(".mainOriginal").css("display", "flex");
                    $(".wholesale.variantId" + data[i].variant_id).remove();
                }
            }
        }
    });
}

document.addEventListener('click', function(e) {
    document.querySelectorAll('#predictive-search').forEach(function(elem) {
        elem.style.display = 'none';
    });
});
  
class CompanyOrders extends HTMLElement {
    constructor() {
        super();
        
        this.email = this.getAttribute('data-email');
        this.account = this.getAttribute('data-account-id');
        this.token = this.getAttribute('data-company-token');
    }

    connectedCallback() {
        this.getOrders();
    }

    getOrders() {
        let payload = {
          "email": this.email,
          "account": this.account,
          "token": this.token
        };

        fetch('https://ama.thecut.net.au/ama20/api/company-orders', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            let html = '';
            let email = this.email;
            let account = this.account;
            let token = this.token;
            
            if (data.orders.length > 0) {
              data.orders.forEach(order => {
                  html += `<tr role="row">`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="${order.name}"><a href="#" aria-label="" data-view-order="${order.id}" data-order-name="${order.name}"><span class="order-name">${order.name}</span><span class="css-spinner" style="display: none;"></span></a></td>`;
                  html += `<td headers="RowOrder ColumnDate" role="cell" data-label="${order.created_at.split('T')[0]}">${order.created_at.split('T')[0]}</td>`;
                  html += `<td headers="RowOrder ColumnPayment" role="cell" data-label="${order.financial_status}">${order.financial_status}</td>`;
                  html += `<td headers="RowOrder ColumnFulfillment" role="cell" data-label="${order.fulfillment_status}">${order.fulfillment_status}</td>`;
                  html += `<td headers="RowOrder ColumnTotal" role="cell" data-label="${Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order.current_total_price)}">${Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(order.current_total_price)}</td>`;
                  html += `</tr>`;
              });
      
              this.querySelector('table tbody').innerHTML = html;
              this.querySelectorAll('table tbody [data-view-order]').forEach(view => {
                  view.addEventListener('click', function(e) {
                      e.preventDefault();

                      this.querySelector('.order-name').style.display = 'none';
                      this.querySelector('.css-spinner').style.display = 'block';
                      let order_id = this.getAttribute('data-view-order');
                      let order_name = this.getAttribute('data-order-name');
      
                      payload = {
                        "email": email,
                        "account": account,
                        "token": token,
                        "order_id": order_id
                      }
      
                      fetch('https://ama.thecut.net.au/ama20/api/get-order', {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                      })
                      .then(response => {
                          return response.json();
                      })
                      .then(data => {
                          console.log(data);
                          let order_details = '<h3>Items</h3>';
      
                          order_details += '<ul>';
                          data.order.line_items.forEach(item => {
                              order_details += `<li>${item.title} x ${item.quantity}</li>`;
                          });
                          order_details += '</ul>';
                          order_details += `<h3>Total Price: ${Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.order.total_price)}</h3>`;
                          order_details += `<h3>Shiping Address</h3>`;
                          order_details += `<p>`;
                          order_details += `${data.order.shipping_address.name}<br />`;
                          order_details += `${data.order.shipping_address.company}<br />`;
                          order_details += `${data.order.shipping_address.address1} ${data.order.shipping_address.address2}<br />`;
                          order_details += `${data.order.shipping_address.city}<br />`;
                          order_details += `${data.order.shipping_address.province}<br />`;
                          order_details += `${data.order.shipping_address.zip}<br />`;
                          order_details += `${data.order.shipping_address.country}<br />`;
                          order_details += `${data.order.shipping_address.phone}<br />`;
                          order_details += `</p>`;
      
                          Swal.fire({
                              title: `Order ${order_name}`,
                              html: order_details,
                              width: "700px",
                              confirmButtonColor: "#253052",
                              confirmButtonText: "Close"
                          });
      
                          this.querySelector('.order-name').style.display = 'block';
                          this.querySelector('.css-spinner').style.display = 'none';
                      });
      
                      
                  });
              });
          }
          else {
              html += `<tr role="row">`;
              html += `<td colspan="5" style="text-align: center;">No company orders found</td>`
              html += `</tr>`;
      
              document.querySelector('company-orders table tbody').innerHTML = html;
          }
        });
    }
}

customElements.define('company-orders', CompanyOrders);


class BackOrders extends HTMLElement {
    constructor() {
        super();
        
        this.email = this.getAttribute('data-email');
        this.account = this.getAttribute('data-account-id');
        this.token = this.getAttribute('data-company-token');
    }

    connectedCallback() {
        this.getOrders();
    }

    getOrders() {
        let payload = {
          "email": this.email,
          "customer_no": this.account,
          "token": this.token
        };

        fetch('https://ama.thecut.net.au/ama20/api/back-orders', {
        // fetch('https://dev.cultivated.agency/ama20/api/back-orders', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(response => {
            return response.json();
        })
        .then(data => {
            let html = '';
            
            if (data.length > 0) {
              data.forEach(order => {
                  html += `<tr role="row">`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Order No">${order.sales_order_no}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="External Doc No">${order.external_doc_no}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Customer Name">${order.customer_name}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Item No">${order.item_no}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Description">${order.item_description}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Unit Of Measurement">${order.unit_of_measure_code}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Qty Ordered">${order.quantity_ordered}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Qty Shipped">${order.quantity_shipped}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="Qty Not Shipped">${order.quantity_not_shipped}</td>`;
                  html += `<td id="RowOrder" role="cell" headers="ColumnOrder" data-label="ETA">${order.eta}</td>`;
                  html += `</tr>`;
              });

              this.querySelector('table tbody').innerHTML = html;
          }
          else {
              html += `<tr role="row">`;
              html += `<td colspan="10" style="text-align: center !important;">No backorders found</td>`
              html += `</tr>`;
      
              this.querySelector('table tbody').innerHTML = html;
          }
        });
    }
}

customElements.define('back-orders', BackOrders);


class StaticTools {
  static waitForElement(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
          const element = document.querySelector(selector);
          if (element) {
            return resolve(element);
          }

          const observer = new MutationObserver(() => {
            const el = document.querySelector(selector);
            if (el) {
              observer.disconnect();
              resolve(el);
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          if (timeout) {
            setTimeout(() => {
              observer.disconnect();
              reject(new Error(`Element ${selector} not found within ${timeout}ms`));
            }, timeout);
          }
      });
  }

  static waitContentChange(selector, callback, exemptSelectors = []) {
      const target = document.querySelector(selector);
      if (!target) {
        console.error(`Element ${selector} not found.`);
        return;
      }

      const observer = new MutationObserver((mutationsList) => {

        for (const mutation of mutationsList) {
          if (
            mutation.type === 'childList' ||
            mutation.type === 'characterData' ||
            mutation.type === 'subtree'
          ) {
            if (exemptSelectors && mutation.target.closest(exemptSelectors)) {
              continue;
            }
            callback(mutation);
            break;
          }
        }
      }); 

      observer.observe(target, {
        childList: true,
        characterData: true,
        subtree: true 
      });

      return observer; 
  }

}

StaticTools.waitForElement('wishlists-drawer').then(el => {

  const exemptSelectors = ['.price-container', '.items-count'];
  StaticTools.waitContentChange('wishlists-drawer .wishlists-drawer__inner', (content) => {

      // if (document.querySelector('.wishlist-card--previously_purchased')) {
      //     document.querySelector('.wishlist-card--previously_purchased').classList.add('expanded');
      // }

      document.querySelectorAll('wishlists-drawer wishlist-item-card').forEach(card => {
          card.querySelector('.price-container>p:first-child').style.display = 'none';

          let variant_retail_price = card.querySelector('.price-container>p:first-child').innerText;
          let variant_retail_price_float = parseFloat(variant_retail_price.replace("$", ""));

          let payload = {
            "customer_no": document.querySelector('.header__icon--account').getAttribute('data-customer-no'),
            "variants": [
              { 
                "id": card.getAttribute('data-id'),
                "retail_price": variant_retail_price_float
              }
            ]
          };
          fetch('https://ama.thecut.net.au/ama20/api/wishlist', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          })
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data.length > 0) {
              if (data[0].variant_id == parseInt(card.getAttribute('data-id')) && data[0].unit_price != null && data[0].unit_price_with_gst != null) {
                let priceContainer = card.querySelector('.price-container');
                var gst_cookie = localStorage.getItem("gst");  

                if (!card.querySelector('.price-item.ExcGst')) {
                  if (gst_cookie !== null && gst_cookie === 'false') {
                    priceContainer.insertAdjacentHTML('beforeend', `<p class="price-item price-item--regular ExcGst">$${data[0].unit_price}</p>`);
                  } else {
                    priceContainer.insertAdjacentHTML('beforeend', `<p class="price-item price-item--regular ExcGst" style="display:none;">$${data[0].unit_price}</p>`);
                  }
                }
                if (!card.querySelector('.price-item.IncGst')) {
                  if (gst_cookie == null || gst_cookie === 'true'){
                    priceContainer.insertAdjacentHTML('beforeend', `<p class="price-item price-item--regular IncGst">$${data[0].unit_price_with_gst}</p>`);
                  } else {
                    priceContainer.insertAdjacentHTML('beforeend', `<p class="price-item price-item--regular IncGst" style="display:none;">$${data[0].unit_price_with_gst}</p>`);
                  }
                }
              } else if (data[0].variant_id == parseInt(card.getAttribute('data-id')) && data[0].message != null && data[0].unit_price_with_gst == null) {
                card.querySelector('.price-container>p:first-child').style.display = 'block';
              }
            }
          })

          if (card.parentElement.parentElement.classList.contains('wishlist-card--previously_purchased')) {
              let variant_id = card.getAttribute('data-id');
              let target_element = card.querySelector('.button--cta-remove');

              if (!card.querySelector('.custom-add-wishlist')) {
                  target_element.insertAdjacentHTML('afterend', `<wishlist-button class="custom-add-wishlist" data-variant-id="${variant_id}"></wishlist-button>`);
              }

              let data_added = card.querySelector('wishlist-button').getAttribute('data-is-added');
              let data_added_index = card.getAttribute('data-index');
              if (data_added && data_added == "true") {
                card.classList.add('hidden');
                if (document.querySelectorAll('.wishlist-card--previously_purchased .wishlist-item__placeholder')[data_added_index]) {
                  document.querySelectorAll('.wishlist-card--previously_purchased .wishlist-item__placeholder')[data_added_index].classList.add('hidden');
                }
              } else {
                card.classList.remove('hidden');
                if (document.querySelectorAll('.wishlist-card--previously_purchased .wishlist-item__placeholder')[data_added_index]) {
                  document.querySelectorAll('.wishlist-card--previously_purchased .wishlist-item__placeholder')[data_added_index].classList.remove('hidden');
                }
              }
          }
          
      }); 

        let new_purchased_count = document.querySelectorAll('.wishlist-card--previously_purchased wishlist-item-card:not(.hidden)').length;
        if (document.querySelector('.wishlist-card--previously_purchased .items-count')) {
          document.querySelector('.wishlist-card--previously_purchased .items-count').textContent = `${new_purchased_count} items`;
        }

        document.querySelectorAll('.item-card__atc-container button').forEach(button => {
              button.addEventListener('click', function() {
                setTimeout(() => {
                  fetch('/cart.js')
                  .then(response => response.json())
                  .then(cart => {
                    if (!document.querySelector('#cart-icon-bubble .cart-count-bubble')) {
                      document.querySelector('#cart-icon-bubble>svg+.visually-hidden').insertAdjacentHTML('afterend', `<div class="cart-count-bubble cart-count-wishlist-bubble"><span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} item</span></div>`);
                    }

                    if (document.querySelector('#cart-icon-bubble .cart-count-bubble.cart-count-wishlist-bubble')) {
                      document.querySelector('#cart-icon-bubble .cart-count-bubble.cart-count-wishlist-bubble').innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} item</span>`;
                    }


                    let itemsArr = [];
                    for (let i = 0; i < cart.items.length; i++) {
                        itemsArr[i] = {
                          "line_item_id": cart.items[i].key,
                          "product_id": cart.items[i].product_id,
                          "sku": cart.items[i].sku ,
                          "title": cart.items[i].title,
                          "variant_id": cart.items[i].variant_id,
                          "retail_price": (Number(cart.items[i].price) / 100).toString(),
                          "properties": [],
                          "quantity": cart.items[i].quantity
                        }
                    }
                    
                    let detailsdata = {
                      "customer_email": customerEmail,
                      "original_customer_no": originalCustomerNo,
                      "customer_no": customerNo,
                      "child_customer_no": childCustomerNo,
                      "note": cart.note,
                      "items": itemsArr
                    };

                    getCartTotal(cart.items_subtotal_price, free_shipping_threshold, detailsdata, "wishlist");
                  })
                  .catch(error => {
                    console.error('Error fetching cart:', error);
                  });
                },500);
              });
            });

  }, exemptSelectors);

}).catch(err => {
    console.error(err);
});
